import useTypedContext from "hooks/useTypedContext";
import { ApiKey } from "types/generated";
import { AccountContext } from "views/AccountWrapper";

import useIsNonRootApiKeyManagementEnabled from "./useIsNonRootApiKeyManagementEnabled";

/**
 * Edit details, reset or delete a specific API key.
 * Root admins can manage every key, other users only the keys they created.
 */
const useCanManageApiKey = (apiKey: Pick<ApiKey, "creator">): boolean => {
  const { viewer } = useTypedContext(AccountContext);
  const isNonRootManagementEnabled = useIsNonRootApiKeyManagementEnabled();

  return viewer.admin || (isNonRootManagementEnabled && apiKey.creator === viewer.id);
};

export default useCanManageApiKey;
